import { render, staticRenderFns } from "./KennelSignatureText.vue?vue&type=template&id=75292c16"
import script from "./KennelSignatureText.vue?vue&type=script&lang=ts"
export * from "./KennelSignatureText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports